// Branch accent colours, set by Colby at OOB-5: Dallas blue, Houston red,
// Austin yellow, San Antonio green.
//
// They exist for ONE job — a wall flyer pinned in the wrong shop should be a
// glance, not a read. Four sheets differing only by a word are easy to mix up
// in a stack coming off a printer.
//
// SAN ANTONIO'S GREEN IS DELIBERATELY NOT THE IDEA-LANE GREEN. Both appear on
// the same flyer — the branch as a band, the lane as a rule beside a heading —
// and the first pass had them one hue apart (#639922 against #1D9E75), which
// read as "both green" at a glance. Colby's instruction at OOB-5: make the
// greens different.
//
// So San Antonio is a deep forest green and the idea lane stays a mid teal-
// green. They now differ in VALUE as well as hue, which is what survives a
// black-and-white photocopy and a shop wall in bad light.
export const BRANCHES = [
  { id: 1, slug: 'dallas', name: 'Dallas', color: '#378ADD' },
  { id: 2, slug: 'houston', name: 'Houston', color: '#E24B4A' },
  { id: 3, slug: 'austin', name: 'Austin', color: '#E8B71A' },
  { id: 4, slug: 'san_antonio', name: 'San Antonio', color: '#22671F' },
];

// The two lane colours, used on the flyer AND on the app's front door so the
// wall and the screen agree. Kept here rather than only in CSS because the
// PDF cannot read a stylesheet.
export const LANE_IDEA_COLOR = '#1D9E75';
export const LANE_CONCERN_COLOR = '#8B5FBF';

// Read from the logo file itself at OOB-5 rather than eyeballed: the mark's
// two opaque colours are #000000 (5651 px) and #93D50A (1108 px).
export const DR_BLACK = '#000000';
export const DR_GREEN = '#93D50A';

export const CATEGORIES = [
  { value: 'general', label: 'General' },
  { value: 'safety', label: 'Safety' },
  { value: 'equipment', label: 'Equipment' },
  { value: 'scheduling', label: 'Scheduling' },
  { value: 'culture', label: 'Culture' },
];

export function branchNameById(id) {
  const b = BRANCHES.find((br) => br.id === Number(id));
  return b ? b.name : 'Unknown branch';
}

export function branchIdBySlug(slug) {
  const b = BRANCHES.find((br) => br.slug === slug);
  return b ? b.id : null;
}

export const STATUS_LABEL = {
  new: 'Received',
  in_review: 'In review',
  resolved: 'Resolved',
};

export const SUGGESTION_ACCENT = '#8B5FBF';

// #478's fourth ruling, Speak Up OOB-6. What the person who submitted sees
// above each answer.
//
// Colby: "when the admin does reply it should let the sender of the idea know
// it was either the admin or the branch manager who replied."
//
// THE WORDS ARE NOT NEW ONES. Each is lifted from the sentence the reporter
// already read on the form they filled in — the idea form says "Your branch
// manager will read this", the concern form says "Ownership reads this
// personally" — so the same vocabulary meets them twice and the reply is
// recognisably from the party they were promised.
//
// ROLE, NEVER A NAME. Gate decision D6 stands unchanged: a reporter never sees
// "Angie" or "Sarah". The database has recorded which of the three wrote each
// message since OOB-2 widened the sender check; nothing surfaced it, so two
// different people's answers looked identical. This makes the stored role
// visible, and adds no information the system did not already hold.
//
// 'submitter' is absent on purpose — the reporter's own message needs no label
// telling them who they are, and a lookup that returns nothing is the right
// answer rather than a gap.
export const SENDER_LABEL = {
  manager: 'Your branch manager',
  handler: 'Ownership',
};